import { FC, useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import queryString from 'query-string'
import Flatpickr from "react-flatpickr";
import {Vietnamese} from "flatpickr/dist/l10n/vn.js"
import { PaginateModel } from "../../../models/PaginateModel";
import { SearchModel } from "../../../models/DebtModel";
import { PaginationLength } from "../../../../_metronic/partials/pagination/PaginationLength";
import * as DebtCRUD from '../DebtCRUD';
import { PaginationHeader } from "../../../../_metronic/partials/pagination/PaginationHeader";
import { Paginate } from "../../../../_metronic/partials/pagination/Paginate";
import AgencyDebtTable from "./AgencyDebtTable";
import { DEFAULT_PER_PAGE } from "../../../constants/common";
import AgencyDebtModal from "./AgencyDebtModal";
import { Toast, download } from "../../../modules/common/helper";
import { GetStoreIfo, UserLoggedIn } from "../../../hooks/PermissionChecker";
import { IAgent } from "../../../models/AgentModel";
import { AbilityModel, ModalModel } from "../../../models/AbilityModel";
import { formatPrice } from "../../../selectors";
import ReceiptVoucherModal from "../../abilities/receipt-voucher/ReceiptVoucherModal";
import { HeaderModel } from "../../../models/CommonModel";
import ConfigModal from "./ConfigModal";
import useMasterData from "../../../hooks/useMaster";
import { update } from "../../abilities/AbilitiesCRUD";
import moment from "moment";
import DropDown from "../../../components/Control/DropDown";

const AgencyDebt: FC = () => {
    const intl = useIntl();

    const history = useHistory();

    const { master } = useMasterData();

    const storeInfo = GetStoreIfo();

    const fp = useRef<any>(null);

    const salesRef = useRef<any>(null);

    const parseParams = (params: SearchModel) => {
        if (params.page) {
            params.page = +params.page
        }
        if (params.per_page) {
            params.per_page = +params.per_page
        }
        return params
    }
    const searchHistory = history.location.search;

    const initParams: SearchModel = parseParams(queryString.parse(searchHistory))

    const [dataPaginate, setDataPaginate] = useState<PaginateModel<IAgent>>();

    const [hideCols, setHideCols] = useState<string[]>([]);

    const [configModal, setConfigModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });

    const [receiptVoucherModal, setReceiptVoucherModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });

    const [debtDetailModal, setDebtDetailModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });

    const [totalDebt, setTotalDebt] = useState<number>(0);
    
    const initRange:any = [initParams?.start_date ?? moment(storeInfo?.created_at).format('YYYY-MM-DD'), initParams?.end_date ?? moment().format('YYYY-MM-DD')]
    
    const initSearch = {
        page: 1,
        per_page: 20,//DEFAULT_PER_PAGE,
        store_id: UserLoggedIn().store_id,
        start_date: initRange[0],
        end_date: initRange[1]
    }

    const [search, setSearch] = useState<SearchModel>(initSearch)

    useEffect(() => {
        document.title = 'Sento - Công nợ khách hàng';
    })

    useEffect(() => {
        getData({ ...search, ...initParams });
    }, []);

    const getData = async (params?: SearchModel) => {
        const { data: resData } = await DebtCRUD.getAgencyDebt({ ...params });
        const objQuery = { ...params }
        if (objQuery.page === 1) {
            delete objQuery.page
        }
        if (objQuery.per_page === DEFAULT_PER_PAGE) {
            delete objQuery.per_page
        }
        history.push({ search: `?${queryString.stringify(objQuery)}` })
        setDataPaginate(resData?.paginate_data);
        setTotalDebt(resData?.total_debt)
        setSearch(params ?? {});
    }

    const handlePageChange = (data: any) => {
        getData({ ...search, page: data.selected + 1 })
    }

    const handlePageLengthChange = (e: any) => {
        getData({ ...search, page: 1, per_page: +e.target.value })
    }

    const handleSearch = (e: any) => {
        e.preventDefault();
        getData({ ...search, page: 1 })
    }

    const handleClearSearch = (e: any) => {
        e.preventDefault();
        setSearch(initSearch);
        if (fp.current?.flatpickr) {
            fp.current.flatpickr.clear();
        }
        salesRef.current?.clearValue();
        getData(initSearch)
    }

    const handleSubmit = async (values: any, actions: any) => {
        const formData = new FormData();
        Object.keys(values).forEach((key) => {
            formData.append(key, values[key]);
        });
        formData.append('purpose', 'sales');

        if (values?.id) {
            handleUpdateAbility(formData, values?.id)
            return
        }

        handleCreateAbility(formData)
        
    };

    const handleCreateAbility = async (formData: FormData) => {
        let result = DebtCRUD.store(formData);
        let message = 'Tạo phiếu thu thành công!'
        result.then(res => {
            Toast.fire({
                icon: 'success',
                title: message
            })
            setReceiptVoucherModal({ ...receiptVoucherModal, show: false })
            getData({ ...search, page: 1 })
        }).catch(error => {
            const response = error.response
            let message: string = '';
            if (response?.status === 422) {
                if (response?.data?.errors) {
                    const arrMess = [];
                    for (const [key, mess] of Object.entries(response?.data?.errors)) {
                        arrMess.push(mess);
                    }
                    message = arrMess.join("\n")
                }
            } else {
                message = 'Đã có lỗi xảy ra vui lòng liên hệ Admin'
            }
            Toast.fire({
                icon: 'error',
                title: message
            })
        });
    }

    const handleUpdateAbility = async (formData: FormData, id: number) => {
        let result = update(formData, id);
        let message = 'Cập nhật phiếu thu thành công!'
        result.then(res => {
            Toast.fire({
                icon: 'success',
                title: message
            })
            setReceiptVoucherModal({ ...receiptVoucherModal, show: false })
            getData({ ...search, page: 1 })
        }).catch(error => {
            const response = error.response
            let message: string = '';
            if (response?.status === 422) {
                if (response?.data?.errors) {
                    const arrMess = [];
                    for (const [key, mess] of Object.entries(response?.data?.errors)) {
                        arrMess.push(mess);
                    }
                    message = arrMess.join("\n")
                }
            } else {
                message = 'Đã có lỗi xảy ra vui lòng liên hệ Admin'
            }
            Toast.fire({
                icon: 'error',
                title: message
            })
        });
    }

    const handleViewDetail = (agency: IAgent) => {
        setDebtDetailModal({ ...debtDetailModal, show: true, data: { ...debtDetailModal?.data, agency: agency } })
    }

    const handleReceiptVoucher = async (agency: IAgent) => {
        setReceiptVoucherModal({ ...receiptVoucherModal, show: true, data: { ...receiptVoucherModal?.data, agency: agency } })
    }

    const header: HeaderModel[] = [
        {
            label: intl.formatMessage({ id: 'AGENCY.NAME' }),
            style: { minWidth: "150px" },
            field: 'name',
            sortable: true
        },
        {
            label: intl.formatMessage({ id: 'AGENCY.DEBT.DATE' }),
            style: { minWidth: "150px" },
            field: 'ability_max_date',
            sortable: true
        },
        {
            label: intl.formatMessage({ id: 'AGENCY.DEBT.TOTAL' }),
            style: { minWidth: "250px" },
            field: 'debt',
            sortable: true
        }
    ]

    const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
        const currentSearch = { ...search };
        const sortParams: SearchModel = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
        if (direction === 'none') {
            delete sortParams.sort_by;
            delete sortParams.sort_direction;
        }
        getData({ ...sortParams });
    }

    const handleChangeVisCols = (e: any) => {
        let hiddenCols = [...hideCols];
        if (!e.target?.checked) {
            setHideCols([...hiddenCols, e.target.name])
        } else {
            setHideCols(hiddenCols.filter((item) => item !== e.target.name))
        }
    }

    const handleExportDebt = async (template: string) => {
        const { data } = await DebtCRUD.exportAgencyDebt({ ...search, template: template });
        download(data, 'agency-debt');
    }

    const onChangeHasDebt = (e: any) => {
        const checked = e.target.checked
        let newSearch = {
            ...initSearch,
            has_debt: checked ? 1 : 0
        }
        getData(newSearch);
    }

    return <div className="card">
        <div className="card-header p-3">
            <div className="col-md-12">
                <form onSubmit={handleSearch}>
                    <div className="row">
                        <div className="col-md-4">
                            <label className="form-label">Tìm kiếm</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder=""
                                name="keyword"
                                value={search.keyword || ''}
                                onChange={(e) => setSearch({ ...search, keyword: e.target.value })}
                                autoComplete='nope'
                            />
                        </div>
                        <div className='col-md-4 '>
                            <label className="form-label">{intl.formatMessage({ id: 'COMMON.TIME' })}</label>
                            <Flatpickr
                                ref={fp}
                                onChange={(date) => {
                                    let startDate = moment(date[0]).format('YYYY-MM-DD');
                                    let endDate = moment(date[1]).format('YYYY-MM-DD');
                                    setSearch({ ...search, start_date: startDate, end_date: endDate });
                                }}
                                options={{
                                    mode: "range",
                                    dateFormat: 'd-m-Y',
                                    locale: Vietnamese,
                                    enableTime: false,
                                    defaultDate: [moment(initRange[0]).format('DD-MM-YYYY'), moment(initRange[1]).format('DD-MM-YYYY')],
                                }}
                                className='form-control'
                                placeholder=''
                            />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12 col-md-4">
                            <div className="form-check mt-2">
                                <input className="form-check-input" type="checkbox" value="" id="has_debt"
                                    name='has_debt'
                                    onChange={onChangeHasDebt} />
                                <label htmlFor="has_debt" className="form-check-label mb-2">Hiển thị công nợ</label>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <div className="btns-group d-flex align-items-center">
                                <button
                                    className="col-auto btn btn-primary my-1 me-2"
                                    onClick={handleSearch}
                                >
                                    <i className="bi bi bi-search fs-4"></i> {intl.formatMessage({ id: 'COMMON.SEARCH' })}
                                </button>
                                <button
                                    className="col-auto btn btn-danger my-1 me-2"
                                    type="button"
                                    onClick={handleClearSearch}
                                >
                                    <i className="bi bi-eraser-fill fs-1"></i> Re-search
                                </button>
                                <DropDown
                                    classString="my-1 col-auto"
                                    items={[
                                        {
                                            value: "accounting",
                                            label: "Mẫu kế toán",
                                            description: "Đầy đủ chi tiết số liệu",
                                            icon: "bi bi-file-earmark-excel-fill text-success",
                                        },
                                        {
                                            value: "default",
                                            label: "Mẫu khách hàng",
                                            description: "Đơn giản, dễ theo dõi",
                                            icon: "bi bi bi-file-earmark-check-fill text-primary",
                                        },
                                    ]}
                                    onChange={(val) => handleExportDebt(val)}
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div className="card-body p-3">
            <div className="row justify-content-between align-items-center mb-3">
                <div className='col-12 col-md-6'>
                    <PaginationHeader from={dataPaginate?.meta?.from || 0} to={dataPaginate?.meta?.to || 0}
                        total={dataPaginate?.meta?.total || 0} />
                </div>
                <div className='col-12 col-md-6 text-start text-md-end'>
                    <h3>Tổng cộng: <span className="text-bold">{formatPrice(totalDebt)} VNĐ</span></h3>
                </div>
            </div>
            <AgencyDebtTable
                data={dataPaginate?.data || []}
                handleSubmit={handleSubmit}
                handleViewDetail={handleViewDetail}
                handleReceiptVoucher={handleReceiptVoucher}
                openColConfig={() => setConfigModal({ ...configModal, show: true })}
                header={header}
                hideCols={hideCols}
                handleSort={handleSort}
            />
            <ReceiptVoucherModal
                {...receiptVoucherModal}
                onClose={() => { setReceiptVoucherModal({ ...receiptVoucherModal, show: false }) }}
                onSubmit={handleSubmit}
            />
            <AgencyDebtModal
                {...debtDetailModal}
                onClose={() => { setDebtDetailModal({ ...debtDetailModal, show: false }) }}
                handleEditItem={(item: AbilityModel) => setReceiptVoucherModal({...receiptVoucherModal, mode: 'edit', data: item, show: true})}
            />
        </div>
        <div className="card-footer d-flex justify-content-between paginate-wrapper">
            <PaginationLength selected={search.per_page || DEFAULT_PER_PAGE} onChange={handlePageLengthChange} />
            <Paginate
                pageCount={dataPaginate?.meta?.last_page || 0}
                onPageChange={handlePageChange}
                forcePage={(search.page || 1) - 1}
            />
        </div>
        <ConfigModal
            {...configModal}
            header={header}
            hideCols={hideCols}
            handleChangeVisCols={handleChangeVisCols}
            onClose={() => { setConfigModal({ ...configModal, show: false }) }}
        />
    </div>
}
export default AgencyDebt;